// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__ny3Sq","unreadBadge":"styles_unreadBadge__1KNyZ","modalContent":"styles_modalContent__zw8ap","modal":"styles_modal__2iHFQ"};